import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { injectConfig, configShape } from '@client/hoc/config';

import { getCampaignGridImage, getCampaignMobileImage } from '../../../../helpers/images';
import {
    TWENTY_FOUR_HOURS_IN_MILLISECONDS
} from '../../../../config/constants';

import UpcomingCampaign from './UpcomingCampaign';
import OpenCampaign from './OpenCampaign';

import styles from './campaign.scss';

export class Campaign extends PureComponent {
    render() {
        const {
            campaign,
            isUpcoming,
            dimension,
            columnCount,
            showDelivery,
            position,
            minHeight
        } = this.props;

        var campaignStyle = {
            visibility: 'visible',
            backgroundImage: ''
        };
        const openCampaignPosition = position.replace(',', '|'); // because tracking requirements

        return (
            <div styleName="wrapper">
                {isUpcoming ?
                    <UpcomingCampaign
                        campaign={campaign}
                        dimension={dimension}
                        campaignStyles={campaignStyle}
                        columnCount={columnCount}
                        minHeight={minHeight}
                        imageUrl={this.getImageUrl()}
                    /> :
                    <OpenCampaign
                        campaign={campaign}
                        dimension={dimension}
                        campaignStyles={campaignStyle}
                        columnCount={columnCount}
                        showDelivery={showDelivery}
                        position={openCampaignPosition}
                        minHeight={minHeight}
                        imageUrl={this.getImageUrl()}
                    />
                }
            </div>
        );
    }

    getImage() {
        const {
            dimension,
            campaign,
            isUpcoming
        } = this.props;

        if (isUpcoming) {
            return getCampaignGridImage(campaign, dimension);
        }

        return getCampaignMobileImage(campaign);
    }

    getImageUrl() {
        const { config, campaign } = this.props;
        const image = this.getImage();

        return image ? `${config.getUrl('campaign', campaign.hasLogo)}${image}` : null;
    }

    componentDidMount() {
        const campaign = this.props.campaign;
        const specialTimerThreshold = campaign.dateEnd - Date.now() - TWENTY_FOUR_HOURS_IN_MILLISECONDS;

        if (campaign.options && campaign.options.specialTimer && specialTimerThreshold > 0) {
            this.timer = setTimeout(() => {
                this.setState({
                    updateCampaignTimer: true
                });
            }, specialTimerThreshold);
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}

Campaign.propTypes = {
    campaign: PropTypes.object.isRequired,
    isUpcoming: PropTypes.bool.isRequired,
    dimension: PropTypes.string.isRequired,
    campaignStyles: PropTypes.object.isRequired,
    columnCount: PropTypes.number,
    showDelivery: PropTypes.bool,
    position: PropTypes.string.isRequired,
    config: configShape,
    minHeight: PropTypes.number
};

export default injectConfig(CSSModules(Campaign, styles, { allowMultiple: true }));
